import React from 'react'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { mobile } from '@/utils/media'
import { mq } from '@/utils/helpers'
import Block from './Block'
import Employment from './Employment'

const EntryPage = props => {
  const { blocks, employment, ...other } = props
  return (
    <Root {...other}>
      <Row>
        <Blocks>
          {blocks && blocks.map((block, index) => (
            <Blocks_Child key={index}><Block {...block}/></Blocks_Child>
          ))}
        </Blocks>
      </Row>
      <Row><Employment list={employment}/></Row>
    </Root>
  )
}

const Root = styled.div``

const Row = styled.div`
  margin-top: 56px;
  @media ${mq.and(mobile)} {
    margin-top: 40px;
  }
  &:first-of-type {
    margin-top: 0px;
    @media ${mq.and(mobile)} {
      margin-top: 0px;
    } 
  }
`

const Blocks = styled.div``

const Blocks_Child = styled.div``

export default ThemeConsumer(EntryPage)
